import _ from "lodash";
import { Reducer } from "redux";

import { ReportsAction, ReportsActionTypes, ReportsState } from "./types";

const initialState: ReportsState = {
  count: 0,
  reports: [],
  isLoading: false,

  generators: {},
};

const reducer: Reducer<ReportsState, ReportsAction> = (state = initialState, action) => {
  switch (action.type) {
    case ReportsActionTypes.FETCH_REQUEST: {
      return { ...state, isLoading: true };
    }
    case ReportsActionTypes.FETCH_ERROR: {
      return { ...state, isLoading: false };
    }
    case ReportsActionTypes.FETCH_SUCCESS: {
      const { count, results } = action.payload;
      return { ...state, count, isLoading: false, reports: results };
    }

    case ReportsActionTypes.REPORT_GENERATOR_START_SUCCESS: {
      const { id } = action.payload;
      return { ...state, generators: { ...state.generators, [id]: action.payload } };
    }

    case ReportsActionTypes.GENERATOR_STATUS_FETCH_SUCCESS: {
      const { id } = action.payload;
      return { ...state, generators: { ...state.generators, [id]: { ...state.generators[id], ...action.payload } } };
    }

    case ReportsActionTypes.REPORT_GENERATOR_IS_COMPLETED: {
      const { id } = action.payload;
      return { ...state, generators: _.omit(state.generators, id) };
    }

    default:
      return state;
  }
};

export default reducer;
